import { injectGlobal } from 'styled-components';
import { white } from './theme/colors';

import gothamBookOtf from '../assets/fonts/gothamhtf-book.otf';
import gothamBookTtf from '../assets/fonts/gothamhtf-book.ttf';
import gothamBookWoff from '../assets/fonts/gothamhtf-book.woff';
import gothamBookWoff2 from '../assets/fonts/gothamhtf-book.woff2';

import gothamThinOtf from '../assets/fonts/gothamhtf-thin.otf';
import gothamThinWoff from '../assets/fonts/gothamhtf-thin.woff';
import gothamThinWoff2 from '../assets/fonts/gothamhtf-thin.woff2';

import ostrichSansOtf from '../assets/fonts/ostrichsans-black.otf';
import ostrichSansTtf from '../assets/fonts/ostrichsans-black.ttf';
import ostrichSansWoff from '../assets/fonts/ostrichsans-black.woff';
import ostrichSansWoff2 from '../assets/fonts/ostrichsans-black.woff2';

export default () => injectGlobal`
html {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: inherit;
  -moz-box-sizing: inherit;
  box-sizing: inherit;
  font-size: inherit;
}

body {
  background-color: ${white};
}

@font-face {
  font-family: 'Gotham';
  src: url('${gothamBookOtf}');
  src: url('${gothamBookOtf}') format('otf'), 
       url('${gothamBookTtf}') format('ttf') , 
       url('${gothamBookWoff2}') format('woff2'),
       url('${gothamBookWoff}') format('woff');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Gotham Thin';
  src: url('${gothamThinOtf}');
  src: url('${gothamThinOtf}') format('otf'), 
       url('${gothamThinWoff2}') format('woff2'),
       url('${gothamThinWoff}') format('woff');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Ostitich Sans';
  src: url('${ostrichSansOtf}');
  src: url('${ostrichSansOtf}') format('otf'), 
       url('${ostrichSansTtf}') format('ttf') , 
       url('${ostrichSansWoff2}') format('woff2'),
       url('${ostrichSansWoff}') format('woff');
  font-weight: normal;
  font-style: normal;
}
`;
